import { descriptorOf } from '../utils/object-utils.js';

// import {  } from '../interfaces/decorator';
/**
 * 设置属性的可配置性
 * @public
 */
function Configurable(value = true) {
    return (target, propertyKey) => {
        var _a;
        const descriptor = descriptorOf(target, propertyKey) || { writable: true, enumerable: true };
        descriptor.configurable = value;
        Object.defineProperty((_a = (target === null || target === void 0 ? void 0 : target.prototype)) !== null && _a !== void 0 ? _a : target, propertyKey, descriptor);
        return descriptor;
    };
}
/**
 * 设置属性为不可配置的
 * @public
 */
function NotConfigurable() {
    return Configurable(false);
}
/**
 * 设置属性的可枚举性
 * @public
 */
function Enumerable(value = true) {
    return (target, propertyKey) => {
        var _a;
        const descriptor = descriptorOf(target, propertyKey) || { writable: true, configurable: true };
        descriptor.enumerable = value;
        Object.defineProperty((_a = (target === null || target === void 0 ? void 0 : target.prototype)) !== null && _a !== void 0 ? _a : target, propertyKey, descriptor);
        return descriptor;
    };
}
/**
 * 设置属性为不可枚举的
 * @public
 */
function NotEnumerable() {
    return Enumerable(false);
}
/**
 * 设置属性的可写性
 * @public
 */
function Writable(value = true) {
    return (target, propertyKey) => {
        var _a;
        const descriptor = descriptorOf(target, propertyKey) || { configurable: true, enumerable: true };
        descriptor.writable = value;
        Object.defineProperty((_a = (target === null || target === void 0 ? void 0 : target.prototype)) !== null && _a !== void 0 ? _a : target, propertyKey, descriptor);
        return descriptor;
    };
}
/**
 * 设置属性为不可写
 * @public
 */
function Readonly() {
    return Writable(false);
}

export { Configurable, Enumerable, NotConfigurable, NotEnumerable, Readonly, Writable };
//# sourceMappingURL=base.js.map
